"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PagedTableFieldRow = void 0;
const react_1 = __importStar(require("react"));
const table_field_row_1 = require("../table-field/table-field-row");
const paged_table_field_context_1 = require("./paged-table-field-context");
const table_field_context_1 = require("../table-field/table-field-context");
exports.PagedTableFieldRow = react_1.memo(react_1.forwardRef(function PagedTableFieldRow(props, ref) {
    const { selectedIndex } = react_1.useContext(table_field_context_1.TableFieldSelectedContext);
    const { page, rowsPerPage } = react_1.useContext(paged_table_field_context_1.PagedTableFieldContext);
    const index = page * rowsPerPage + props.index;
    const selected = index === selectedIndex;
    return (react_1.default.createElement(table_field_row_1.TableFieldRow, Object.assign({}, props, { index: index, selected: selected, ref: ref })));
}));
//# sourceMappingURL=paged-table-field-row.js.map